import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboTipoSangueComponent } from './combo-tipo-sangue.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboTipoSangueComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboTipoSangueComponent]
})
export class ComboTipoSangueModule { }
